import { useSelectedOrganization } from './useSelectedOrganization';
import { useMemo } from 'react';
import { useGetCategoriesQuery, useGetQueueMetadataQuery } from '../models/graphql';

export const usePauseSettings = () => {
  const { selectedWorkspace } = useSelectedOrganization();
  const categoriesResult = useGetCategoriesQuery({
    variables: { workspaceId: selectedWorkspace?.id || '' },
    skip: !selectedWorkspace?.id
  });
  const queueMetaDataResult = useGetQueueMetadataQuery({
    variables: { workspaceId: selectedWorkspace?.id || '' },
    skip: !selectedWorkspace?.id
  });

  return useMemo(() => {
    const categoriesData = categoriesResult.data?.workspace.categories || [];
    const queueMetaData = queueMetaDataResult.data?.workspace.queueMeta || [];

    const seasonallyPausedCategories = categoriesData.filter(category => category.seasonallyPaused);

    const isCategorySeasonallyPaused = (categoryId: string): boolean => {
      return categoriesData.filter(category => category.id === categoryId && category.seasonallyPaused).length > 0;
    };

    const isCategoryPausedForAllSocialProfiles = (categoryId: string): boolean => {
      const filteredToCategory = queueMetaData.filter(meta => meta.category.id === categoryId);
      const filteredPaused = filteredToCategory.filter(meta => meta.paused);
      return filteredPaused.length > 0 && filteredPaused.length === filteredToCategory.length;
    };

    const isSocialProfilePausedForAllCategories = (socialProfileId: string): boolean => {
      const filteredToSocialProfile = queueMetaData.filter(meta => meta.socialProfile.id === socialProfileId);
      const filteredPaused = filteredToSocialProfile.filter(meta => meta.paused);
      return filteredPaused.length > 0 && filteredPaused.length === filteredToSocialProfile.length;
    };

    const isSocialProfilePausedForCategory = (socialProfileId: string, categoryId: string): boolean => {
      return (
        queueMetaData.filter(
          meta => meta.socialProfile.id === socialProfileId && meta.category.id === categoryId && meta.paused
        ).length > 0
      );
    };
    return {
      workspacePublishingPaused: selectedWorkspace?.settings.queuesPaused || false,
      autoImportersPaused: selectedWorkspace?.settings.autoImportsPaused || false,
      seasonallyPausedCategories,
      isCategorySeasonallyPaused,
      isCategoryPausedForAllSocialProfiles,
      isSocialProfilePausedForAllCategories,
      isSocialProfilePausedForCategory
    };
  }, [
    categoriesResult.data?.workspace.categories,
    queueMetaDataResult.data?.workspace.queueMeta,
    selectedWorkspace?.settings.queuesPaused,
    selectedWorkspace?.settings.autoImportsPaused
  ]);
};
